export enum InvestigationsSectionText {
  Reports = "Reports",
  Requests = "Requests"
}

export enum InvestigationsSectionKeys {
  Reports = "reports",
  Requests = "requests"
}
